import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Hint } from 'react-autocomplete-hint';
import { useState, useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { FeedbackContext } from "../../../../Components/Context/FeedbackContext";
import { Loading } from "../../../../Components/Loading/Loading";
import { ErrorConnection } from "../../../../Components/Error/Error";
import { Spinner } from 'react-bootstrap';
import * as Api from '../../../../api/Api';
import { useGetToken } from '../../../../Hooks/CustomHooks';
import $ from 'jquery';


function GuardarContrato({ unidadEconomicaId, idObj, contrato, setContrato, local, setLocal, listaContratosSearch,
    listaTitlesSearch, setSmShow }) {

    const [guardar, setGuardar] = useState(false);
    const token = useGetToken();

    function setLocalAndContrato(localValue) {
        let localValueUpper = localValue.toUpperCase();
        let pos = listaTitlesSearch.indexOf(localValueUpper);
        setLocal(localValueUpper);
        if (pos > -1) {
            setContrato(listaContratosSearch[pos]);
        }
    }

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let { data, isLoading, isError, error, isFetching } = useQuery(
        ["MapaCalorMantenimiento_guardar", {
            unidadEconomica: unidadEconomicaId, idObj: idObj, contrato: contrato, local: local
        }],
        async () => await Api.MapaCalorMantenimiento_guardarContrato(
            { unidadEconomicaId: unidadEconomicaId, idObj: idObj, contrato: contrato, local: local, token: token }
        ),
        {
            enabled: Boolean(guardar)
        }
    );

    useEffect(() => {
        if (data) {
            console.log('data', data);
            console.log('data.message', data.message);
            if (data.success == true) {
                setGuardar(false);
                setSmShow(true, data.message);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, isError: data.errorId });
            }
        }
    }, [data]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error} />)
    return (
        <>
            <Modal

                show={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => setSmShow(false)}
            >
                <Modal.Header className='header-personalizable' closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Locatario: {idObj}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <Hint options={listaContratosSearch} allowTabFill>
                            <input
                                required
                                type="text"
                                className="form-control"
                                placeholder="Contrato"
                                value={contrato}
                                style={{ textTransform: "uppercase" }}
                                onChange={e => setContrato(e.target.value)}
                            />
                        </Hint>
                        <label id='required_contrato' style={{ display: 'none' }} className="text-danger">Ingrese contrato</label>

                        <br />
                        <Hint options={listaTitlesSearch} allowTabFill >
                            <input
                                required
                                type="text"
                                className="form-control"
                                placeholder="Local"
                                value={local}
                                style={{ textTransform: "uppercase" }}
                                onChange={e => setLocalAndContrato(e.target.value)}
                            />
                        </Hint>

                        <div className="notice d-flex bg-light-blue rounded  p-6 mt-3">
                            <span className="svg-icon svg-icon-2hx svg-icon-info me-4 mb-5 mb-sm-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path opacity="0.3" d="M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z" fill="black"></path>
                                    <path d="M19 15V18C19 18.6 18.6 19 18 19H6C5.4 19 5 18.6 5 18V15C6.1 15 7 14.1 7 13V10C7 7.6 8.7 5.6 11 5.1V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V5.1C15.3 5.6 17 7.6 17 10V13C17 14.1 17.9 15 19 15ZM11 10C11 9.4 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7C10.3 7 9 8.3 9 10C9 10.6 9.4 11 10 11C10.6 11 11 10.6 11 10Z" fill="black"></path>
                                </svg>
                            </span>
                            <div className="d-flex flex-stack flex-grow-1">

                                <div className="fw-bold">
                                    <div className="fs-6 text-blue">
                                        Presionar TAB para Autocompletar los datos</div>
                                </div>

                            </div>

                        </div>
                        <label id='required_local' style={{ display: 'none' }} className="text-danger">Ingrese Local</label>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => setSmShow(false)}>
                        Cerrar
                    </button>
                    <button type="submit" className="btn btn-primary" onClick={
                        () => {
                            if (contrato != '' && local != '') {
                                $('#required_contrato').attr("style", "display='none'");
                                $('#required_local').attr("style", "display='none'");
                                return setGuardar(true);
                            }
                            else {
                                if (contrato == '') $('#required_contrato').attr("style", "display='block'");
                                if (local == '') $('#required_local').attr("style", "display='block'");
                                return null;
                            }
                        }
                    }>
                        Guardar
                    </button>
                    <button type="submit" className="btn btn-dark" onClick={
                        () => {
                            setContrato('');
                            setLocal('');
                            return setTimeout(() => { setGuardar(true) }, 500);
                        }
                    }>Limpiar</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default GuardarContrato
